import { useMemo } from 'react';

import { useFlag } from '../../../services/launchDarkly';
import { useStores } from '../../../stores/useStores';
import type { FreeSpinWidgetDataType, WidgetEntry } from '../types';
import { isFreeSpinMiniGame } from '../utils';

export function useMiniGameWidgets() {
  const { userFreeSpinsStore } = useStores();
  const { userFreeSpinsData } = userFreeSpinsStore;
  const userFsWidgetsFF = useFlag('user_free_spins_widgets_feature', true);

  const miniGameWidgets: FreeSpinWidgetDataType[] = useMemo(() => {
    if (!userFsWidgetsFF || !userFreeSpinsData || userFreeSpinsData.length === 0) {
      return [];
    }
    return userFreeSpinsData
      .filter((freeSpin) => isFreeSpinMiniGame(freeSpin.provider))
      .map((freeSpin) => ({
        key: freeSpin.id,
        event: freeSpin,
        dataTestId: 'user-free-spin-widget',
      }));
  }, [userFreeSpinsData, userFsWidgetsFF]);

  return useMemo(
    () => miniGameWidgets.map((data): WidgetEntry<'miniGame'> => ({ data, type: 'miniGame', id: data.key })),
    [miniGameWidgets],
  );
}
